export default {
	addToBasket: "addToBasket",
	basketUpdated: "basketUpdated",
}
